export default __webpack_public_path__ + "static/media/Google.d49d24e5.svg";